import { ThemeOptions } from "@mui/material/styles";
import { defaultTheme } from "react-admin";

import type {} from "@mui/x-data-grid-pro/themeAugmentation";
import { colors } from "./colors";

export const theme: ThemeOptions = {
  ...defaultTheme,
  palette: {
    secondary: defaultTheme.palette?.secondary,
    success: {
      main: colors.greenLight,
      contrastText: colors.greenLightContrast
    },
    warning: {
      main: colors.orange,
      contrastText: colors.white
    },
    background: {}
  },
  components: {
    ...defaultTheme.components,
    MuiCssBaseline: {
      styleOverrides: {
        ".RaEdit-card": {
          border: "1px solid",
          borderRadius: "8px!important",
          borderColor: "rgba(0, 0, 0, 0.23)",
          boxShadow: "none!important"
        }
      }
    },
    MuiFormControl: { defaultProps: { fullWidth: undefined, size: "small" } },
    MuiTextField: { defaultProps: { fullWidth: undefined } },
    MuiAutocomplete: { defaultProps: { fullWidth: undefined } },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    RaSimpleFormIterator: { defaultProps: { fullWidth: undefined } },
    RaTranslatableInputs: { defaultProps: { fullWidth: undefined } },
    MuiFormControlLabel: {
      styleOverrides: {
        labelPlacementStart: {
          justifyContent: "space-between"
        }
      }
    },
    // MuiFormLabel: {
    //   styleOverrides: {
    //     root: {
    //       color: colors.blackText
    //     }
    //   }
    // },
    MuiTooltip: {
      defaultProps: {
        arrow: true
      },
      styleOverrides: {
        tooltip: {
          fontSize: 14
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeaderTitle: {
          fontWeight: "bold"
        },
        root: {
          border: "none",
          "--DataGrid-pinnedBackground": defaultTheme.palette?.background?.paper
        },
        filterForm: {
          alignItems: "baseline",
          WebkitAlignItems: "unset",
          ".MuiTextField-root": {
            display: "block",
            marginTop: 0
          },
          ".MuiDataGrid-filterFormLogicOperatorInput": {
            marginBottom: 8
          },
          ".MuiDataGrid-filterFormDeleteIcon": {
            marginBottom: 10
          },
          ".MuiDataGrid-filterFormValueInput": {
            minWidth: 240
          }
        },
        pinnedColumns: {
          backgroundColor: "#FFFFFF",
          boxShadow: "none"
        },
        columnHeader: {
          border: "none"
        }
      }
    }
  }
};

export const darkTheme: ThemeOptions = {
  ...theme,
  palette: {
    ...theme.palette,
    mode: "dark",
    success: {
      main: colors.greenDark,
      contrastText: colors.greenLight
    },
    warning: {
      main: colors.orangeDark,
      contrastText: colors.orangeLighter
    }
  },
  components: {
    ...theme.components,
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: colors.white
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        ...theme.components?.MuiDataGrid?.styleOverrides,
        pinnedColumns: {
          backgroundImage: "none",
          backgroundColor: "transparent",
          boxShadow: "none"
        }
      }
    }
  }
};
